import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        await googleSession(sessionId);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError(errMsg(e));
        toast.error(errMsg(e));
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [googleSession, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
      <LogoMark className="w-12 h-12 rounded-2xl" />
      {error ? (
        <p className="text-rose-600 text-sm">{error}</p>
      ) : (
        <div className="flex items-center gap-2 text-slate-500"><Loader2 className="w-4 h-4 animate-spin" /> Signing you in…</div>
      )}
    </div>
  );
}
